import { MatomoProvider, createInstance } from '@jonkoops/matomo-tracker-react';

const matomoUrl = process.env.REACT_APP_MATOMO_URL!;
const matomoSiteId = process.env.REACT_APP_MATOMO_SITEID!;

const instance = createInstance({
  urlBase: matomoUrl,
  siteId: parseInt(matomoSiteId, 10),
});

const MatomoProviderWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (matomoUrl) {
    return <MatomoProvider value={instance}>{children}</MatomoProvider>;
  }
  return <>{children}</>;
};

export default MatomoProviderWrapper;
